import * as $ from 'jquery';
import { DragDropManager } from './DragDropManager';
import { IDisposable } from '../definition/IDisposable';

// tslint:disable-next-line:interface-name
interface IDragSafeGlass {
  Element: JQuery;
  enableHitTests(): void;
  disableHitTests(): void;
  show(): void;
}


class SimplifiedDragSafeGlass implements IDragSafeGlass, IDisposable {
  public Element: JQuery;
  private parentElement: HTMLElement = null;

  public static readonly GlassClass: string = 'tab-glass';
  private static readonly ClearGlassClass: string = 'clear-glass';
  private static readonly OpaqueGlassClass: string = 'opaque-glass';
  private static readonly HtmlTemplate: string =
    `<div class='${SimplifiedDragSafeGlass.GlassClass} ${SimplifiedDragSafeGlass.ClearGlassClass}'/>`;

  public constructor() {
    this.Element = $(SimplifiedDragSafeGlass.HtmlTemplate);
    this.parentElement = document.body;
    DragDropManager.registerDragGlass(this);
  }

  public dispose(): void {
    DragDropManager.unregisterDragGlass(this);
    this.Element.remove();
  }

  public disableHitTests(): void {
    this.Element.css('pointer-events', 'none');
  }

  public enableHitTests(): void {
    this.Element.css('pointer-events', 'auto');
  }

  public show(): void {
    if (this.Element.parent()[0] !== this.parentElement) {
      this.Element.appendTo(this.parentElement);
    }
    if (this.opaque) {
      this.Element.toggleClass('glass-fade-in-immediate', true);
    }
    this.Element.show();
  }

  public get opaque(): boolean {
    return this.Element.hasClass(SimplifiedDragSafeGlass.OpaqueGlassClass);
  }

  public set opaque(value: boolean) {
    this.Element.toggleClass(SimplifiedDragSafeGlass.ClearGlassClass, !value);
    this.Element.toggleClass(SimplifiedDragSafeGlass.OpaqueGlassClass, value);
  }
}

export { IDragSafeGlass, SimplifiedDragSafeGlass };
